import { createFileRoute } from '@tanstack/react-router'

import { RouteModal } from '@/components/route-modal'

import { CustomerGroupForm } from './-customer-group-form'

export const Route = createFileRoute('/_authenticated/_general/customer-groups/create')({
	component: RouteComponent,
	staticData: {
		crumb: ({ context: { L } }) => L.CustomerGroups.CreateTitle()
	}
})

function RouteComponent() {
	return (
		<RouteModal asDrawer>
			<CustomerGroupForm />
		</RouteModal>
	)
}
